/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { CspAgreementStats } from "./CspAgreementStats";
import {
  CspAgreementStatsFromJSON,
  CspAgreementStatsFromJSONTyped,
  CspAgreementStatsToJSON,
  CspAgreementStatsToJSONTyped,
} from "./CspAgreementStats";
import type { CspTimelineEvent } from "./CspTimelineEvent";
import {
  CspTimelineEventFromJSON,
  CspTimelineEventFromJSONTyped,
  CspTimelineEventToJSON,
  CspTimelineEventToJSONTyped,
} from "./CspTimelineEvent";
import type { CspMonthlyPoint } from "./CspMonthlyPoint";
import {
  CspMonthlyPointFromJSON,
  CspMonthlyPointFromJSONTyped,
  CspMonthlyPointToJSON,
  CspMonthlyPointToJSONTyped,
} from "./CspMonthlyPoint";
import type { CustomerSpecificPricingAgreement } from "./CustomerSpecificPricingAgreement";
import {
  CustomerSpecificPricingAgreementFromJSON,
  CustomerSpecificPricingAgreementFromJSONTyped,
  CustomerSpecificPricingAgreementToJSON,
  CustomerSpecificPricingAgreementToJSONTyped,
} from "./CustomerSpecificPricingAgreement";

/**
 *
 * @export
 * @interface CustomerSpecificPricingDetail
 */
export interface CustomerSpecificPricingDetail {
  /**
   *
   * @type {CustomerSpecificPricingAgreement}
   * @memberof CustomerSpecificPricingDetail
   */
  agreement: CustomerSpecificPricingAgreement;
  /**
   *
   * @type {CspAgreementStats}
   * @memberof CustomerSpecificPricingDetail
   */
  stats: CspAgreementStats;
  /**
   *
   * @type {Array<CspMonthlyPoint>}
   * @memberof CustomerSpecificPricingDetail
   */
  monthly: Array<CspMonthlyPoint>;
  /**
   *
   * @type {Array<CspTimelineEvent>}
   * @memberof CustomerSpecificPricingDetail
   */
  timeline: Array<CspTimelineEvent>;
}

/**
 * Check if a given object implements the CustomerSpecificPricingDetail interface.
 */
export function instanceOfCustomerSpecificPricingDetail(
  value: object,
): value is CustomerSpecificPricingDetail {
  if (!("agreement" in value) || value["agreement"] === undefined) return false;
  if (!("stats" in value) || value["stats"] === undefined) return false;
  if (!("monthly" in value) || value["monthly"] === undefined) return false;
  if (!("timeline" in value) || value["timeline"] === undefined) return false;
  return true;
}

export function CustomerSpecificPricingDetailFromJSON(
  json: any,
): CustomerSpecificPricingDetail {
  return CustomerSpecificPricingDetailFromJSONTyped(json, false);
}

export function CustomerSpecificPricingDetailFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomerSpecificPricingDetail {
  if (json == null) {
    return json;
  }
  return {
    agreement: CustomerSpecificPricingAgreementFromJSON(json["agreement"]),
    stats: CspAgreementStatsFromJSON(json["stats"]),
    monthly: (json["monthly"] as Array<any>).map(CspMonthlyPointFromJSON),
    timeline: (json["timeline"] as Array<any>).map(CspTimelineEventFromJSON),
  };
}

export function CustomerSpecificPricingDetailToJSON(
  json: any,
): CustomerSpecificPricingDetail {
  return CustomerSpecificPricingDetailToJSONTyped(json, false);
}

export function CustomerSpecificPricingDetailToJSONTyped(
  value?: CustomerSpecificPricingDetail | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    agreement: CustomerSpecificPricingAgreementToJSON(value["agreement"]),
    stats: CspAgreementStatsToJSON(value["stats"]),
    monthly: (value["monthly"] as Array<any>).map(CspMonthlyPointToJSON),
    timeline: (value["timeline"] as Array<any>).map(CspTimelineEventToJSON),
  };
}
